<script>
    import Information from './../../components/information.vue';
    export default {
        extends: Information,
        data(){
            return {
                backRoute:'custom.order.summary',
            }
        },
        methods:{
            submitInformation() {
                if (this.allInformationValidated) {
                    this.$store.dispatch('completedInformation');
                    this.$router.push({
                        name:'custom.order.delivery'
                    });
                }
            },
        }
    }
</script>

<style scoped>

</style>
